/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ESignProvider {
    EID_EASY = 'EID_EASY',
}
